<template>
<div class="container">
    <Header title="解锁门票" />

    <div class="user-info-wrap">
        <div class="bg-wrap"></div>
        <div class="title-wrap flex ccc">
            <div class="title">解锁门票</div>
            <div class="pic-wrap avatar-pic-wrap">
                <img :src="agent_info.avatar || Images.img_avatar_default_pic" alt="" class="pic-img avatar-img">
            </div>
            <div class="user-name">{{agent_info.name}}的解锁门票</div>
        </div>
    </div>

    <div class="ticket-info-wrap">
        <div class="title">{{ dataSources.title || '解锁众修课程，享更多权益～'}}</div>
        <div class="btn-wrap">
            <div class="btn-item receive-btn-item" @click="_onPressBtnItem">{{btnStatusName}}</div>
        </div>
        <div class="remark-wrap flex ccc">
            <div class="title flex rcc">赠言</div>
            <div class="remark-text">{{dataSources.desc}}</div>
        </div>
    </div>

    <div class="user-wrap">
        <div class="title-wrap">
            <div class="title">已领取（{{dataSources.use_num}}/{{dataSources.total_num}}）</div>
        </div>
        <ul class="list-wrap user-list-wrap">
            <li class="list-item user-list-item flex rcb" v-for="(item, index) in receive_user_list" :key="index">
                <div class="left-wrap flex rcs">
                    <img :src="item.student_avatar || Images.img_avatar_default_pic" alt="" class="avatar-img" />
                    <span class="name">{{item.student_name_text}}</span>
                </div>
                <div class="right-wrap">
                    <div class="time-wrap">{{item.update_time}}</div>
                </div>
            </li>
        </ul>

        <van-empty description="暂无人领取～" v-if="receive_user_list.length < 1 && !loading" />
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import {wxSetup, wxShare} from '@/utils/wxShare'
import Header from '@/components/Header'
export default {
    components: {
        Header,
    },
    computed: {
        ...mapGetters(["userInfo"]),
        btnStatusName() {
            let _btnStatusNameTemp = '立即发放';
            if (this.dataSources.agent_id != this.userInfo.id) {
                if (this.dataSources.is_received > 0) {
                    _btnStatusNameTemp = '您已经领取成功，无法再次领取';
                } else {
                    _btnStatusNameTemp = this.dataSources.use_num < this.dataSources.total_num ? '立即领取' : '您来晚一步，已经被领取完了';
                }
            }
            return _btnStatusNameTemp;
        }
    },
    data() {
        return {
            loading: false,
            grant_id: this.$route.query.grant_id || '',
            remark: '领取后，可立即解锁众修课程，快来领取吧',
            dataSources: {
                use_num: '',
                total_num: '',
            },
            agent_info: {},
            receive_user_list: [{
                student_avatar: '',
                student_name_text: '梦',
                update_time: '2022-03-04 16:40:00'
            }],
        };
    },
    created() {},
    async mounted() {
        await this._requestDataSources();
        this._setupWechatConfig();
    },
    methods: {

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('_urlTemp---->', _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.title,
                    desc: this.dataSources.desc,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },

        async _requestDataSources() {
            let url = this.API.ticket_grant_detail;
            let data = {
                grant_id: this.grant_id,
            };
            this.loading = true;
            const result = await this.$post(url, data);
            this.loading = false;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
                this.agent_info = result.data.agent;
                this.receive_user_list = result.data.receive_user_list;
            }
        },

        _onPressBtnItem() {
            if (this.dataSources.agent_id != this.userInfo.id) {
                if (this.dataSources.use_num < this.dataSources.total_num && this.dataSources.is_received < 1) {
                    this._onSubmitReceive();
                } else {
                    console.log('已领取完，无法领取 / 已领取---->', '已领取完，无法领取 / 已领取');
                }
            } else {
                this._onSubmitSend();
            }
        },

        // 确认赠送
        async _onSubmitSend() {
            this.$emit(this.Constants.SHOWSHAREPOPUP, true);

        },

        // 确认领取
        async _onSubmitReceive() {
            let url = this.API.ticket_use_ticket;
            let data = {
                grant_id: this.grant_id,
            };
            this.loading = true;
            const result = await this.$post(url, data);
            this.loading = false;
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this._requestDataSources();
            }
        },

    },
};
</script>

<style lang="less" scoped>
.container {
    flex: 1;
    background: #fff;
    min-height: 100vh;

    .user-info-wrap {
        overflow: hidden;
        position: relative;
        padding-bottom: 50px;

        .bg-wrap {
            top: -58vw;
            left: -10vw;
            width: 120vw;
            height: 100vw;
            overflow: hidden;
            object-fit: cover;
            position: absolute;
            background-size: 88%;
            background-color: #f60;
            border-radius: 0 0 50% 50%;
            background-repeat: no-repeat;
            background-position: center 50vw;
            background-image: url(../../assets/img/img_page_bg1.png);
        }

        .title-wrap {
            position: relative;
            z-index: 19;

            .title {
                color: #fff;
                font-size: 2rem;
                font-weight: 600;
                margin: 3.5rem auto 5rem;
            }

            .avatar-pic-wrap {
                width: 10rem;
                height: 10rem;
                overflow: hidden;
                background: #fff;
                object-fit: cover;
                border-radius: 5px;
                box-shadow: 1px 1px 2px #c6c5c5;
            }

            .user-name {
                margin-top: 1rem;
            }
        }
    }

    .ticket-info-wrap {
        padding: 0 1.5rem;

        .title {
            font-size: 1.6rem;
        }

        .btn-wrap {
            margin: 3rem 0;

            .btn-item.receive-btn-item {
                color: #fff;
                height: 4rem;
                border-radius: 5px;
                margin: 1rem 0 2rem;
                box-shadow: 0 0 1px 0px #6c6c6c61;
                background: linear-gradient(45deg, #7180eb, #acb5f0);
            }
        }

        .remark-wrap {

            .title {
                color: #7785eb;
                font-size: 1.6rem;

                &:before,
                &:after {
                    content: '';
                    height: 2px;
                    width: 4rem;
                    display: block;
                    margin: 0 1rem;
                    background: #7785eb;
                }
            }

            .remark-text {
                margin: 1rem;
                line-height: 1.6;
                color: #666;
            }
        }
    }

    .user-wrap {
        padding: 1.5rem;

        .title-wrap {
            margin: 1rem 0;

            .title {
                color: #666;
                font-size: 1.4rem;
            }
        }

        .user-list-wrap {
            .user-list-item {
                padding: 1rem 0;
                border-bottom: 1px dashed #ddd;
                &:last-of-type {
                    border: 0;
                }

                .left-wrap {

                    .avatar-img {
                        width: 4rem;
                        height: 4rem;
                        margin-right: 1rem;
                    }

                    .name {
                        font-size: 1.5rem;
                    }
                }

                .right-wrap {

                    .time-wrap {
                        color: #999;
                    }
                }
            }
        }
    }

}
</style>
